module.exports = __webpack_public_path__ + "static/media/TRIAL1-if-wrong-after-10-sec.3f29957c.mp3";